import api from "@/api.js";

export default {
  state: {
    siteData: {},
    fullLoading: true,
    navigationDrawer: true,
    siteSettings: {},
    offlineMode: false
  },
  mutations: {
    setFullLoader(state, loading) {
      setTimeout(() => {
        state.fullLoading = loading;
      }, 500);
    },
    setNavigationDrawer(state, drawer) {
      state.navigationDrawer = drawer;
    },
    setOfflineMode(state, mode) {
      state.offlineMode = mode;
    }
  },
  actions: {
    checkOnlineStatus({ commit }) {
      commit("setOfflineMode", !navigator.onLine);
    },
    setFullLoaderState({ commit }, loading) {
      commit("setFullLoader", loading);
    },
    async setNavigationDrawerState({ commit }, payload) {
      commit("setNavigationDrawer", payload);
    },

    randomString({ commit }, payload) {
      var mask = "";
      if (payload.chars.indexOf("a") > -1) mask += "abcdefghijklmnopqrstuvwxyz";
      if (payload.chars.indexOf("A") > -1) mask += "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      if (payload.chars.indexOf("#") > -1) mask += "0123456789";
      if (payload.chars.indexOf("!") > -1)
        mask += "~`!@#$%^&*()_+-={}[]:\";'<>?,./|\\";
      var result = "";
      for (var i = payload.len; i > 0; --i)
        result += mask[Math.floor(Math.random() * mask.length)];
      return result;
    },

    async contactSupport({ commit }, payload) {
      payload.toEmail = "admin@tdrisolutions.com";
      payload.subject = "Support request from PWA";

      await api.post("simpleSoftwareContactForm", payload);
    },
    async getCarriageWayUploadURL({ commit }, payload) {
      const apiResponse = await api.post("carriagewaySections/createS3UploadKey");

      return {
        'Result': apiResponse.data.Result,
        'Response': apiResponse.data
      }
    },
    async uploadCarriageWay({ commit }, payload) {

      await api.post("carriagewaySections/uploadNewFile", payload);
      return true;
    }
  },
  getters: {
    siteData(state) {
      return state.siteData;
    },
    fullLoading(state) {
      return state.fullLoading;
    },
    navigationDrawer(state) {
      return state.navigationDrawer;
    },
    offlineMode(state) {
      return state.offlineMode;
    }
  }
};
